import {BrowserMultiFormatReader} from '@zxing/browser'
import {Dispatch, FC, SetStateAction, useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useFormContext} from 'react-hook-form'
import {ScanModelDto} from '../../../../model/multiUserCrew.model'
import {MULTI_USER_CREW_SERVICES} from '../../../../services/multi-user-crew.service'
import {ShowSnackBar} from '../../../../../../util/functions'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  onScanSuccess?: () => void
}

export const ModalScanCleaningActivity: FC<Props> = ({show, setShow, onScanSuccess}) => {
  const {watch} = useFormContext()
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const readerRef = useRef<BrowserMultiFormatReader | null>(null)
  const controlsRef = useRef<any>(null)
  const isProcessingRef = useRef(false)

  const startScanner = async () => {
    if (controlsRef.current) return

    if (!readerRef.current) {
      readerRef.current = new BrowserMultiFormatReader()
    }

    try {
      const devices = await BrowserMultiFormatReader.listVideoInputDevices()

      if (!devices || devices.length === 0) {
        alert('No se encontró ninguna cámara')
        return
      }

      const deviceId = devices[devices.length - 1].deviceId

      isProcessingRef.current = false

      controlsRef.current = await readerRef.current.decodeFromVideoDevice(
        deviceId,
        videoRef.current!,
        (result, error) => {
          if (result && !isProcessingRef.current) {
            isProcessingRef.current = true
            const text = result.getText()
            handleBarcodeDetected(text)
          }
        },
      )
    } catch (err) {
      console.error('Error iniciando cámara:', err)
    }
  }

  const stopScanner = () => {
    try {
      controlsRef.current?.stop()
      controlsRef.current = null
    } catch (e) {
      console.warn('Error al detener el scanner:', e)
    }
  }

  const handleBarcodeDetected = async (code: string) => {
    stopScanner()

    const dto: ScanModelDto = {
      ServiceSchedulingId: watch('ProgramacionServicioId'),
      ActividadConfiguracionId: code,
    }

    try {
      const {data: response} = await MULTI_USER_CREW_SERVICES.createScan(dto)

      if (!response.error) {
        ShowSnackBar('Actividad ingresada correctamente', 'success', {autoClose: 5000})
        setTimeout(() => {
          onScanSuccess?.()
        }, 300)
      } else {
        ShowSnackBar(response.message || 'Error al ingresar la actividad', 'error', {
          autoClose: 5000,
        })
      }
    } catch (e: any) {
      ShowSnackBar(e.message || 'Error al ingresar la actividad', 'error', {autoClose: 5000})
    } finally {
      handleClose()
      isProcessingRef.current = false
    }
  }

  useEffect(() => {
    if (show) {
      startScanner()
    } else {
      stopScanner()
    }

    return () => {
      stopScanner()
    }
  }, [show])

  const handleClose = () => {
    stopScanner()
    setShow(false)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-mobile-top'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content position-relative'>
        {/* 🎥 Overlay cámara */}
        <div
          className='position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-dark bg-opacity-75'
          style={{zIndex: 1055}}
        >
          <div
            className='bg-black rounded-3 p-3'
            style={{width: '100%', maxWidth: 420, marginTop: '250px'}}
          >
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <span className='text-white fw-bold'>Escanear código de barra</span>
              <button type='button' className='btn btn-sm btn-light' onClick={handleClose}>
                Cerrar
              </button>
            </div>

            <video ref={videoRef} style={{width: '100%', borderRadius: '8px'}} />

            <div className='mt-2 text-center'>
              <small className='text-white-50'>Apunta la cámara al código de barras</small>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
